export default {
  title: 'Powiadomienia o rezerwacjach',
  label: 'Na jaki adres wysyłać powiadomienia o rezerwacjach?',
  placeholder: 'np. rezerwacje@twojarestauracja.pl',
  helper:
    'Wystarczy dowolny adres e-mail — nie wymaga dostępu do panelu. Można go później zmienić lub dodać kolejne w Rezerwacje → Ustawienia → Powiadomienia i potwierdzenia.',
  errors: {
    required: 'Należy podać adres e-mail, aby otrzymywać powiadomienia o rezerwacjach.',
    invalid: 'Należy podać prawidłowy adres e-mail, np. imie@restauracja.pl.',
  },
};
